import classNames from 'classnames';
import { MotionConfig, m } from 'motion/react';

import Spinner from '@/components/Icons/Spinner';

import s from './ProgressIndicator.module.scss';

type PropsTypes = {
  isPage?: boolean;
  hasSpace?: boolean;
  size?: number;
  isAbsolute?: boolean;
  isCentered?: boolean;
  color?: string;
  isInline?: boolean;
  className?: string;
  label?: string;
};

const MotionSpinner = m.create(Spinner);

const ProgressIndicator: React.FC<PropsTypes> = ({
  isPage = false,
  hasSpace = false,
  size = 24,
  isAbsolute = false,
  isCentered = false,
  isInline = false,
  color,
  className,
  label,
}): JSX.Element => (
  <MotionConfig reducedMotion='never'>
    <span
      className={classNames(
        s['progress-indicator'],
        {
          [s['progress-indicator--inline']]: isInline,
          [s['progress-indicator--absolute']]: isAbsolute,
          [s['progress-indicator--page']]: isPage,
          [s['progress-indicator--centered']]: isCentered,
          [s['progress-indicator--has-space']]: hasSpace,
        },
        className,
      )}
      style={label ? undefined : { maxHeight: `${size}px` }}
    >
      <MotionSpinner
        animate={{ rotate: 180 }}
        transition={{ duration: 0.5, ease: 'linear', repeat: Infinity }}
        size={size}
        color={color || 'var(--color-gray-75)'}
      />
      {label && (
        <m.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={s['progress-indicator__label']}>
          {label}
        </m.span>
      )}
    </span>
  </MotionConfig>
);

export default ProgressIndicator;
